const initialState = {
  graph3: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GRAPH3':
      const { graph3 } = action;
      return {
        ...state,
        graph3,
      };
    default:
      return state;
  }
};

export const setGraph3 = (
  graph3,
) => ({
  type: 'GRAPH3',
  graph3,
});
